import { Pipe, PipeTransform } from '@angular/core';

import { IAdditionalComponentsCatalogueCart } from '../../enclosure/models/product-accessories.model';

@Pipe({
    name: 'additionalComponentsAddedInCatalogue',
    standalone: false
})
export class AdditionalComponentsAddedInCataloguePipe implements PipeTransform {

  transform(addedProducts: IAdditionalComponentsCatalogueCart[], reference: string): number {
    return addedProducts?.find(addedProduct => addedProduct?.product?.reference === reference)?.quantity || 0;
  }

}
